import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControlOptions, AbstractControl } from '@angular/forms';
import { StripeService, StripeCardComponent } from 'ngx-stripe';
import {
  StripeCardElementOptions,
  StripeElementsOptions
} from '@stripe/stripe-js';
@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
    @ViewChild(StripeCardComponent) card: StripeCardComponent;

    cardOptions: StripeCardElementOptions = {
        style: {
          base: {
            iconColor: '#666EE8',
            color: '#31325F',
            fontWeight: '300',
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSize: '18px',
            '::placeholder': {
              color: '#CFD7E0'
            }
          }
        }
      };
    
      elementsOptions: StripeElementsOptions = {
        locale: 'en'
      };
    
      stripeTest: FormGroup;
    
    constructor(private formBuilder: FormBuilder, private stripeService: StripeService) {}
    ngOnInit(): void {
        this.stripeTest = this.formBuilder.group({
            "name": new FormControl('', Validators.required),
          });
    } 

    createToken(): void {
        const name = this.stripeTest.get('name').value;
        this.stripeService.createPaymentMethod({
            type: 'card',
            card: this.card.element,
            billing_details: {
              name: this.stripeTest.get('name').value,
            },
          }).subscribe((result) => {
            if (result) {
              // Use the token
            } else if (result.error) {
              // Error creating the token
            }
          });
      }

}
